import { render, staticRenderFns } from "./TrixTableEditor.vue?vue&type=template&id=9070ed9c&"
import script from "./TrixTableEditor.vue?vue&type=script&lang=js&"
export * from "./TrixTableEditor.vue?vue&type=script&lang=js&"
import style0 from "./TrixTableEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports